module.exports = __webpack_public_path__ + "static/media/Recruitments_Welfare01.2ffb2d83.png";